export default __webpack_public_path__ + "4e9b1d923ead2f1e2674058253046571.png";